import '@cta/frontend';

import '@campact/camper/core/CmprAccordion';

import './index.scss';

import AppBoot from '@cta/frontend/javascripts/app_boot';
import App from './app.vue';

import Rails from '@rails/ujs';

Rails.start();

AppBoot.start(App);
